module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-29-ad752ad3775c3255db9ce2bfd1bbf399.svg";